import { Component, effect, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { PrimeNGConfig } from 'primeng/api';
import { AngularQueryDevtools } from '@tanstack/angular-query-devtools-experimental';
import * as layoutReducer from './+state/layout/layout.reducer';
import * as layoutActions from './+state/layout/layout.actions';
import * as layoutSelectors from './+state/layout/layout.selectors';
import { environment } from '../environments/environment';
import { AuthService, SessionExpiredDialogComponent } from '@kanzi-apes/kanzi-authenticator';

@Component({
    imports: [RouterModule, AngularQueryDevtools, SessionExpiredDialogComponent],
    selector: 'kanzi-apes-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  public isProduction = environment.production;
  private authService = inject(AuthService);
  private translate = inject(TranslateService);

  layoutStore = inject(Store<layoutReducer.LayoutState>);
  languageSelected = this.layoutStore.selectSignal(
    layoutSelectors.getLayoutLanguage
  );

  langEffects = effect(() => {
    const lang = this.languageSelected();
    this.translate.use(lang);
  });

  constructor(private primengConfig: PrimeNGConfig) {
    this.translate.addLangs(['en', 'es', 'pr']);
    this.translate.setFallbackLang('es');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(
      browserLang ? (browserLang.match(/en|es/) ? browserLang : 'en') : 'en'
    );
    this.layoutStore.dispatch(
      layoutActions.changeLanguage({
        language: this.translate.getCurrentLang(),
      })
    );
    console.log('language: ', this.translate.getCurrentLang());
  }
  ngOnInit() {
    // Verificar y refrescar sesión al iniciar la app
    this.authService.checkAndRefreshToken().subscribe({
      next: (session) => {
        if (session && session.isValid()) {
          console.log('Session válida al iniciar la app');
          this.authService.startTokenRefreshTimer();
        } else {
          console.log('No hay sesión válida al iniciar la app');
        }
      },
      error: (error) => {
        console.error('Error al verificar sesión inicial:', error);
      },
    });
    this.primengConfig.setTranslation({
      emptyMessage: 'No se encontraron resultados',
    });
  }

  ngOnDestroy() {
    this.authService.stopTokenRefreshTimer();
  }
}
